<div class="odx-bar-parent h-100" odxLayout="flex">
  <app-configuration-wizard-back-button #backButton [project]="project" [floorplanGroup]="FloorplanMenuType.MONITORING_KVM">
  </app-configuration-wizard-back-button>

  <odx-wizard #configurationWizard [vertical]="true" (activeStepChanged)="setActiveStep($event)">
    <odx-wizard-step i18n="@@kvmConfiguration.wizard.step0">Category</odx-wizard-step>
    <odx-wizard-step>{{ currentTransmitterStepLabel }}</odx-wizard-step>
    <odx-wizard-step i18n="@@kvmConfiguration.wizard.step2" [class.odx-wizard-step--visible]="needsReceiver"
      >Receiver</odx-wizard-step
    >
    <odx-wizard-step i18n="@@kvmConfiguration.wizard.step3">Accessories</odx-wizard-step>
    <odx-wizard-step i18n="@@kvmConfiguration.wizard.step4">Summary</odx-wizard-step>
  </odx-wizard>

  <app-kvm-category-selection
    class="w-100 h-100"
    [hidden]="activeStep !== 0"
    [originalDeviceType]="originalTransmitterDeviceType"
    (categorySelected)="setSelectedCategory($event)"
    (formReady)="selectedCategoryForm = $event"
  ></app-kvm-category-selection>

  @if ((selectedFamily$ | async) && family) {
    <app-option-selector
      class="w-100"
      [hidden]="activeStep !== 1"
      [selectedFamily]="family"
      [precomputedOptionDisplays]="transmitterOptionDisplays"
      [originalOptions]="transmitterOriginalOptions"
      [title]="currentTransmitterStepTitle"
      [step]="transmitterStep"
      [category]="MonitoringCategory.KVMS"
      [categoryLabel]="currentTransmitterCategoryLabel"
      [deviceTypeFilter]="selectedCategory"
      (optionsSelect$)="setSelectedTransmitter($event)"
      (formReady)="selectedTransmitterForm = $event"
    >
    </app-option-selector>
  }

  @if ((selectedFamily$ | async) && needsReceiver && family) {
    <app-option-selector
      class="w-100"
      [hidden]="activeStep !== 2"
      [selectedFamily]="family"
      [originalOptions]="currentReceiverOriginalOptions"
      [title]="KvmSelectorTitleKeyMap[KvmSelectorType.RECEIVER]"
      [step]="family.steps[1]"
      [category]="MonitoringCategory.KVMS"
      [categoryLabel]="overviewCategoryLabelMap[KvmSelectorType.RECEIVER]"
      [hasQuantities]="true"
      [allowedDeviceIds]="matchingReceiverDeviceIds"
      (optionsSelect$)="setSelectedReceiver($event)"
      (formReady)="selectedReceiverForm = $event"
    >
    </app-option-selector>
  }

  @if ((selectedFamily$ | async) && accessoriesFamily && accessoriesStep) {
    <app-option-selector
      class="w-100"
      [hidden]="activeStep !== 3"
      [selectedFamily]="accessoriesFamily"
      [originalOptions]="originalConfiguration?.accessories"
      [title]="KvmSelectorTitleKeyMap[KvmSelectorType.ACCESSORIES]"
      [step]="accessoriesStep"
      [category]="MonitoringCategory.KVMS"
      [categoryLabel]="overviewCategoryLabelMap[KvmSelectorType.ACCESSORIES]"
      [hasQuantities]="true"
      (optionsSelect$)="setSelectedAccessories($event)"
      (formReady)="selectedAccessoriesForm = $event"
    >
    </app-option-selector>
  }

  @if ((selectedFamily$ | async) && activeStep === 4) {
    <app-monitoring-overview
      [hidden]="activeStep !== 4"
      [title]="KvmSelectorTitleKeyMap[KvmSelectorType.OVERVIEW]"
      [sections]="groupedSections"
      [showCategory]="true"
    ></app-monitoring-overview>
  }

  <app-product-config-stepper-bar
    (dismiss)="backButton.navigateBack()"
    (next)="onSubmit()"
    (previous)="onPrevious()"
    [activeStep]="!needsReceiver && activeStep >= 3 ? activeStep - 1 : activeStep"
    [steps]="!needsReceiver && activeStep >= 1 ? steps - 1 : steps"
  >
  </app-product-config-stepper-bar>
</div>
